declare var get_bugsnag_configuration: any;

export async function init_bugsnag(): Promise<void> {
    const config = get_bugsnag_configuration();
    if (!config.enabled) {
        return;
    }

    const { default: Bugsnag } = await import('@bugsnag/js');

    Bugsnag.start({
        apiKey: config.apiKey,
        onError: function(event: any) {
            const lr = (window as any).LogRocket;
            event.addMetadata('session', { sessionURL: lr ? lr.sessionURL : '' });
        },
        redactedKeys: [
            /^password$/i,
            /^cc_/,
            /^credit_card/i
        ],
        logger: null,
        // Inline script tracking serializes the whole page's outerHTML on start and wraps every
        // timer/event listener, which showed up as a long task. Errors are still reported without it.
        trackInlineScripts: false,
        enabledReleaseStages: [
            'production',
            'staging',
            'development'
        ],
        releaseStage: config.releaseStage,
        appVersion: config.appVersion
    });

    if (config.user_data.user_id > 0) {
        Bugsnag.setUser(config.user_data.id, config.user_data.email, config.user_data.name);
    }

    // Expose on window — utils.js calls window.bugsnagClient.notify(), which maps to Bugsnag.notify() in v7.
    (window as any).bugsnagClient = Bugsnag;
}
